<template>
  <div class="grid grid-cols-6 gap-x-6 laptop:grid-cols-12">
    <slot />
  </div>
</template>
<script setup lang="ts"></script>
<style lang="scss" scoped></style>
